/**
 * @Description: 地图 API 服务
 * @Author: TSY
 * @CreateDate: 2025
 */

// 开发环境使用代理，生产环境使用完整域名
const BASE_URL = process.env.NODE_ENV === 'production' ? 'https://map.hxkj.vip' : '';

/**
 * 通用请求方法
 * @param {string} url 请求地址
 * @returns {Promise} 返回 Promise
 */
async function request(url) {
  try {
    const response = await fetch(url);
    const result = await response.json();

    if (result.code === 200 || result.code === 0) {
      return result.data;
    } else {
      throw new Error(result.message || '请求失败');
    }
  } catch (error) {
    console.error('API 请求错误:', error);
    throw error;
  }
}

/**
 * 查询当前区划自己的轮廓
 * @param {string} adcode 行政区划代码（例如：440000 代表广东省）
 * @returns {Promise} 返回该区划的边界 GeoJSON
 * @example
 * // 查询广东省的边界
 * queryGeoJson('440000')
 */
export async function queryGeoJson(adcode) {
  const url = `${BASE_URL}/api/geojson/query?adcode=${adcode}`;
  return request(url);
}

/**
 * 查询下级所有区划的轮廓
 * @param {string} parentCode 父级行政区划代码（例如：440000 代表广东省，100000 代表中国）
 * @returns {Promise} 返回下级所有区划的边界 GeoJSON（已拼接好的 FeatureCollection）
 * @example
 * // 查询广东省下所有地级市的边界
 * queryChildrenGeoJson('440000')
 */
export async function queryChildrenGeoJson(parentCode) {
  const url = `${BASE_URL}/api/geojson/children?parentCode=${parentCode}`;
  return request(url);
}

/**
 * 查询下级行政区划列表
 * @param {string} parentCode 父级行政区划代码（100000 代表中国）
 * @returns {Promise} 返回下级行政区划列表
 * @example
 * // 查询中国的所有省级行政区划
 * queryDistrictChildren('100000')
 */
export async function queryDistrictChildren(parentCode) {
  const url = `${BASE_URL}/api/district/children?parentCode=${parentCode}`;
  return request(url);
}
